import TeamMember from "./TeamMember";
import { useGetMemberQuery } from "../../features/members/membersApi";

export default function TeamMembers() {
  const { data: teams, isLoading, isError } = useGetMemberQuery();

  // decide what to render
  let content = null;
  if (isLoading) content = <h1>Loading</h1>;
  if (!isLoading && isError) content = <h1>There was an error</h1>;
  if (!isLoading && !isError && teams?.length === 0)
    content = <h1>No Team Member found!</h1>;
  if (!isLoading && !isError && teams?.length > 0)
    content = teams.map((team) => <TeamMember key={team.id} team={team} />);

  return (
    <div className="mt-8">
      <h3 className="text-xl font-bold">Team Members</h3>
      <div className="mt-3 space-y-4">{content}</div>
    </div>
  );
}
